const Loading = () => {

  return (
    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-secondary"></div>
  );

};

export default Loading;
